module.exports = __webpack_public_path__ + "img/sgp_ubfc.72ec9334.jpg";